import { isEmailValid } from './string-builder.helper'

type ValuesType = 'number' | 'string' | 'email'


export const isNotTypeOnArray = (array: any, key: string, type: ValuesType) => {
  if (type === 'email') return array?.some((x: any) => !isEmailValid(x[key]))
  return array?.some((x: any) => typeof x[key] !== type)
}
